import { useQuery } from "react-query";
import axios from "infra/http";
import { VotacaoPerguntaDetalhesDto } from "../typings";

function usePergunta(id: string, perguntaId?: string) {
  return useQuery(
    [`/mobile/v1/votacao/${id}/pergunta/${perguntaId}`],
    async () => {
      const res = await axios.get<VotacaoPerguntaDetalhesDto>(
        `/mobile/v1/votacao/${id}/pergunta/${perguntaId}`
      );

      return res.data;
    },
    {
      enabled: !!id || !!perguntaId,
    }
  );
}

export default usePergunta;
